import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface SocialMediaLinks {
  facebook_url?: string | null;
  twitter_url?: string | null;
  linkedin_url?: string | null;
  instagram_url?: string | null;
  tiktok_url?: string | null;
  youtube_url?: string | null;
  pinterest_url?: string | null;
}

export const useSocialMediaLinks = () => {
  return useQuery({
    queryKey: ["social-media-links"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("organization_settings")
        .select("facebook_url, twitter_url, linkedin_url, instagram_url, tiktok_url, youtube_url, pinterest_url")
        .maybeSingle();

      if (error) throw error;
      return data as SocialMediaLinks | null;
    },
  });
};
